import { useI18n } from '@/modules/i18n/useI18n';
import type { Link } from '@/payload/components/Link/RichTextLink';

export function getLinkUrl(link: Link) {
	// eslint-disable-next-line react-hooks/rules-of-hooks -- render-time helper, only called from client components
	const { locale } = useI18n();

	if (!link) return '#';

	if (link.linkType === 'contact') return `/${locale}/support#contact`;
	if (link.linkType === 'custom' && link.url) return link.url ?? '#';

	if (link.linkType === 'internal' && link.doc && typeof link.doc.value === 'object' && 'slug' in link.doc.value) {
		if (link.doc.relationTo === 'selfcare') {
			if (link.doc.value.slug === 'home') return `/${locale}/support`;
			return `/${locale}/support/${link.doc.value.slug}`;
		}
	}

	return '#';
}
